import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-dark-900 pt-10 pb-16 px-4 relative overflow-hidden" data-id="element-118">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" data-id="element-119"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-121">
          <h1 className="md:text-5xl lg:text-6xl font-bold text-cream mb-4 text-[32px]" data-id="element-122">
            El algoritmo está criando a tu Hijo.
          </h1>

          <p className="md:text-2xl text-[#4AEFB8] font-semibold mb-8 text-[24px]" data-id="element-123">
            Y podés recuperar su atención en solo 7 días.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-8" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/mgR1pgoFUzSMqNjeXSvrsD/Diseno_sin_titulo_(10).png" alt="MegaPack Niños Sin Pantallas" className="w-full max-w-4xl mx-auto drop-shadow-2xl" data-id="element-125" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="max-w-2xl mx-auto" data-id="element-126">
          <p className="text-cream/80 md:text-lg mb-6 font-[700] font-sans text-[18px]" data-id="element-127">
            Sistema paso a paso para reducir el uso del celular sin gritos ni
            peleas.
          </p>

          <a href="#pricing" className="inline-block bg-cta hover:bg-cta-hover text-white font-bold text-lg md:text-xl py-4 px-10 rounded-full shadow-[0_0_25px_rgba(16,185,129,0.4)] transition-all hover:scale-105 active:scale-95 mb-6" data-id="element-128">
            👉QUIERO RECUPERAR SU ATENCIÓN
          </a>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-cream/60" data-id="element-129">
            <div className="flex items-center" data-id="element-130">
              <Shield className="w-4 h-4 mr-1" data-id="element-131" /> Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-132">
              <Lock className="w-4 h-4 mr-1" data-id="element-133" /> Pago seguro
            </div>
            <div className="flex items-center" data-id="element-134">
              <CreditCard className="w-4 h-4 mr-1" data-id="element-135" /> Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}